import { configureStore } from '@reduxjs/toolkit'
import account from './features/account/slice'
import system from './features/system/slice'
import tag from './features/tag/slice'
import occupation from './features/occupation/slice'
import invitations from './features/invitations/slice'
import joinRequests from './features/join-requests/slice'
import individu from './features/individu/slice'
import organizationForm from './features/organization-form/slice'
import cities from './features/cities/slice'
import provinces from './features/provinces/slice'
import translation from './features/translation/slice'
import search from './features/search/slice'

import organizations from './features/organizations/slice'
import organization from './features/organization/slice'
import organizationPrograms from './features/organization/programs/slice'
import organizationEvents from './features/organization/events/slice'
import organizationResources from './features/organization/resources/slice'
import organizationBlogs from './features/organization/blogs/slice'

import programs from './features/programs/slice'
import programForm from './features/program-form/slice'
import programFormV1 from './features/program-form-v1/slice'
import program from './features/program/slice'

import events from './features/events/slice'
import event from './features/event/slice'
import eventForm from './features/event-form/slice'

import resources from './features/resources/slice'
import resource from './features/resource/slice'
import resourceForm from './features/resource-form/slice'

import blog from './features/blog/slice'
import blogForm from './features/blog-form/slice'
import blogs from './features/blogs/slice'

const store = configureStore({
  reducer: {
    // General
    account,
    system,
    tag,
    occupation,
    invitations,
    joinRequests,
    individu,
    cities,
    provinces,
    translation,
    search,

    // Collections
    organizationForm,
    organizations,
    organization,
    organizationPrograms,
    organizationEvents,
    organizationResources,
    organizationBlogs,
    programForm,
    programFormV1,
    programs,
    program,
    eventForm,
    events,
    event,
    resourceForm,
    resources,
    resource,
    blog,
    blogForm,
    blogs,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false
  })
})

export default store
